export default __webpack_public_path__ + "static/media/cheatday_frenchfries.2b55aa09.jpg";